"use strict";
import { getPublicClient } from "@wagmi/core";
import { wagmiConfig } from "components/Web3Provider/wagmiConfig";
import { useMemo } from "react";
import { useUpdateDelegatedState } from "state/wallets/hooks";
import {
  createDelegationService
} from "features/smartWallet/delegation/delegation";
import { isAddress } from "utilities/src/addresses";
import { getLogger } from "utilities/src/logger/logger";
export function useDelegationService() {
  const updateDelegatedState = useUpdateDelegatedState();
  return useMemo(() => {
    return createDelegationService({
      logger: getLogger(),
      delegationRepository: createDelegationRepository(),
      onDelegationDetected: (payload) => {
        updateDelegatedState({ chainId: String(payload.chainId), address: payload.address });
      }
    });
  }, [updateDelegatedState]);
}
const createDelegationRepository = () => {
  return {
    // checks the bytecode of the wallet (if a contract is deployed)
    getWalletBytecode: async (input) => {
      if (!isAddress(input.address)) {
        throw new Error("Invalid address");
      }
      const publicClient = getPublicClient(wagmiConfig, { chainId: input.chainId });
      if (!publicClient) {
        throw new Error("No public client set");
      }
      const result = await publicClient.getCode({ address: input.address });
      return result ?? "0x";
    }
  };
};
